module.exports = __webpack_public_path__ + "img/clock.61254cc1.svg";